import immutable from 'object-path-immutable';

import { LOGOUT, type LogoutAction } from '../actions/auth.actionTypes';
import {
	ADD_ERROR,
	type AddError,
	type Error as AppError,
	DISMISS_ERROR,
	type DismissError,
} from '../actions/errors.actionTypes';

type ProductActionTypes = AddError | DismissError | LogoutAction;

export interface ErrorsState {
	list: AppError[];
}

const initialState: ErrorsState = {
	list: [],
};

// biome-ignore lint/style/useDefaultParameterLast: parameter order is a fixed contract (Redux reducer signature / existing call sites)
const errors = (state = initialState, action: ProductActionTypes): ErrorsState => {
	switch (action.type) {
		case LOGOUT.SUCCESS:
			return initialState;

		case ADD_ERROR:
			return immutable.push(state, 'list', action.payload);

		case DISMISS_ERROR: {
			const errorIndex = state.list.findIndex((error) => error.id === action.payload.id);

			return immutable.del(state, `list.${errorIndex}`);
		}
	}
	return state;
};

export default errors;
